import { DaumPostcodeResponse, StoreBase } from '@gooduncles/gu-app-schema';

export const convertDaumAddressToStoreBase = (daumResponse: DaumPostcodeResponse) => {
  const {
    address = '',
    roadAddress = '',
    jibunAddress = '',
    sido = '',
    sigungu = '',
    bname = '',
    hname = '',
    roadname = '',
  } = daumResponse ?? {};
  const storeBase: Partial<StoreBase> = {
    address,
    roadAddress,
    jibunAddress,
    sido,
    sigungu,
    bname,
    hname,
    roadname,
  };
  return storeBase;
};
